<template>
  <div class="inline-block">
    <span class="frame text-xs text-white p-2">
      <p class="inner-text">{{ initials }}</p>
    </span>
  </div>

</template>

<script>
export default {
  name: 'NameLogo',
  props: {
    name: {
      type: String,
    },
  },
  computed: {
    initials() {
      return this.name.match(/\b(\w)/g).join('');
    },
  },
};
</script>

<style scoped>
.frame {
  background: #65a0ee;
  border-radius: 50%;
  position: relative;
  display: block;
  text-align: center;
  width: 40px;
  height: 40px;
}

.inner-text {
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/NameLogo.vue